import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
// import Header from './components/Header';
import Home from './pages/Home';
import Footer from './components/Footer';
import NotFound from './components/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import ScrollToTop from './components/ScrollToTop';
import Pricing from './pages/Pricing';
import { IsNotNullOrEmpty } from './utils/valid';
import { config } from './utils/utils';
import { setItem } from './utils/localStorage';

const MainLayout: React.FC = () => (
  <>
    {/* <Header /> */}
    <ScrollToTop />
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/pricing' element={<Pricing />} />

      <Route path='/terms' element={<TermsOfUse />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />

      <Route path='*' element={<NotFound />} />
    </Routes>
    <Footer />
  </>
);

const AppContent: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const referralCode = searchParams.get('refCode');

    if (IsNotNullOrEmpty(referralCode)) {
      setItem(config.REFERRAL_CODE_PARAM_KEY, referralCode);
    }
  }, [location.search]);

  return (
    <>
      <Routes>
        {/* Pages WITH header/footer */}
        <Route path='/*' element={<MainLayout />} />

        {/* Pages WITHOUT header/footer */}
        {/* <Route path='/nfada/:code' element={<NFADACampaign />} /> */}
      </Routes>
    </>
  );
};

// Main App component with Router wrapper
const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;